import { DOMRouteHandler } from './DOMRouteHandler';

export class TemplateProductDnb extends DOMRouteHandler {}
